import { OrderFormState } from './../reducers/order.form.reducer';
import { COMPLETE_ORDER_FEATURE } from '../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );
export const getFormDataState = createSelector(
  getCompleteOrderState,
  (state) => state?.orderForm
);

export const getFormData = createSelector(
  getFormDataState,
  (formState: OrderFormState) => {
    return formState?.data;
  }
);

export const getFormDataLoading = createSelector(
  getFormDataState,
  (formState: OrderFormState) => formState.loading
);

export const getFormDataLoaded = createSelector(
  getFormDataState,
  (formState: OrderFormState) => formState.loaded
);
